import React from 'react'
import ChartBuilderChartGuidelines from './ChartBuilderChartGuidelines'

export default class ChartBuilderGeneral extends React.Component{
  constructor(props){
    super(props);
  };
  
  render(){
    return(
      <div className="container">
        {this.renderNameAndCode()}
        {this.renderChartGuidlines()}
      </div>
    );
  };

  renderNameAndCode() {
    return(
      <div className="row" style={{ paddingLeft: 15 }} >
        <div className="col-md-2">
          <div className="form-group">
            <label>{`${I18n.t('code')}*`}</label>
            <input type="text" maxLength="12" className={this.fieldErrors('Code') ? 'form-control has-errors': 'form-control'} name="code" value={this.props.report_details.code ? this.props.report_details.code : ''} onChange={this.props.onChangeReportDetails} />
            {
              this.fieldErrors('Code')
              ?
                <div className="help-block">
                  <ul>{I18n.t('cant_be_blank')}</ul>
                </div>
              :
                null
            }
          </div>
        </div>
        <div className="col-md-3">
          <label>{`${I18n.t('name')}*`}</label>
          <div className="form-group">
            <input className={this.fieldErrors('Name') ? 'form-control has-errors' : 'form-control'}  name="name" value={this.props.report_details.name ? this.props.report_details.name : ''} onChange={this.props.onChangeReportDetails} />
          {
            this.fieldErrors('Name')
            ?
              <div className="help-block">
                <ul>{I18n.t('cant_be_blank')}</ul>
              </div>
            :
              null
          }
          </div>
        </div>
      </div>
    );
  };

  renderChartGuidlines() {
    return(
      <div className="row" style={{ paddingLeft: 15, paddingRight: 15 }}>
        <ChartBuilderChartGuidelines {...this.props} />
      </div>
    );
  };

  fieldErrors(field){
    var fieldError = false
    this.props.errors.forEach((error) =>{
      if(error.includes(field)){
        fieldError = true
      };
    });
    return fieldError
  };

};